import TwoFactorAuthentication from "./component";

export default TwoFactorAuthentication;
